import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EndpointService } from './endpoint.service';
import { AssetTypeEnum } from '../enums/assetType.enum';

@Injectable({
    providedIn: 'root'
})
export class UploadService extends EndpointService {

    constructor(http: HttpClient) {
        super(http);
    }

    getAssetsPreSignedURL(fileName: string, assetType: AssetTypeEnum) {
        return this.http.get(this.getApiUrl('Upload/GetAssetsPreSignedURL'), {
            params: new HttpParams().set('key', fileName).set('assetType', assetType),
            responseType: 'text'
        });
    }

    uploadFile(signedUrl: string, file: any) {
        return this.http.put(signedUrl, file, {
            headers: {}, responseType: 'blob',
            withCredentials: false
        });
    }
}